import { useEffect, useRef } from "react";
import { useSettings } from "../context/SettingsContext";

// Renders a Cloudflare Turnstile widget when CAPTCHA is enabled & configured.
// Calls onToken(token) on success. Renders nothing when disabled.
export default function Turnstile({ onToken }) {
  const { captcha } = useSettings();
  const ref = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    if (!captcha?.enabled || !captcha?.site_key) return;
    const SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    const render = () => {
      if (!window.turnstile || !ref.current || widgetId.current !== null) return;
      widgetId.current = window.turnstile.render(ref.current, {
        sitekey: captcha.site_key,
        callback: (t) => onToken(t),
        "error-callback": () => onToken(""),
        "expired-callback": () => onToken(""),
        theme: "dark",
      });
    };
    if (window.turnstile) { render(); }
    else if (!document.querySelector(`script[src="${SRC}"]`)) {
      const s = document.createElement("script");
      s.src = SRC; s.async = true; s.defer = true; s.onload = render;
      document.head.appendChild(s);
    } else {
      const t = setInterval(() => { if (window.turnstile) { clearInterval(t); render(); } }, 300);
      return () => clearInterval(t);
    }
    // eslint-disable-next-line
  }, [captcha?.enabled, captcha?.site_key]);

  if (!captcha?.enabled || !captcha?.site_key) return null;
  return <div ref={ref} data-testid="turnstile-widget" className="mt-2" />;
}
